import { LoadingButton } from "@mui/lab";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";

export interface IProps {
    open: boolean;
    loading?: boolean;
    title?: string;
    message: string;
    cancelButtonText: string;
    confirmButtonText: string;
    onClose: any;
    onCancel: any;
    onConfirm: any;
}

export default function ConfirmationDialog(props: IProps) {
    return (
        <Dialog
            maxWidth="md"
            fullWidth
            open={props.open}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    props.onClose();
                }
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
            <DialogContent style={{ padding: "30px 20px" }} dividers>
                <DialogContentText id="alert-dialog-description">
                    <Typography variant="body1">{props.message}</Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <Button
                    id={props.cancelButtonText.toLowerCase()}
                    onClick={props.onCancel}
                    color="warning"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    {props.cancelButtonText}
                </Button>
                <LoadingButton
                    id={props.confirmButtonText.toLowerCase()}
                    loading={props.loading}
                    onClick={props.onConfirm}
                    color="primary"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    {props.confirmButtonText}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
